import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import MasterBBNModifying from "./components/MasterBBNModifying";
import MasterBBNFilter from "./components/MasterBBNFilter";
import {formGroupMasterBBN, initialData, tableColumns} from "./config";
import Api from "../../../Services/Api";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../common/mapper";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment/moment";
import {fetchDataAsync, getUserAccess} from "../../../Services/Utils";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus} from "../../common/Constants";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

class MasterBBN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            filterVisible: false,
            modifyingVisible: false,
            printModalVisible: false,
            deleteModalVisible: false,
            deleteAction: false,
            userAccess: null,
            selectedData: null,
            selectedCabang: null,
            filterData: initialData.filter,
            search: initialData.search,
            submittedFilterData: {},
            tableColumns: [],
            dataTable: [],
            dataCabang: [],
            dataSamsat: [],
            dataVariant: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
            alertCannotDelete: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataCabang();
        this.fetchDataVariant();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (!R.equals(this.state.selectedCabang, prevState.selectedCabang)) {
            this.handleTriggerLoading();
            this.setState((prevState) => ({
                ...prevState,
                filterData: initialData.filter,
                search: initialData.search,
                submittedFilterData: {},
                pagination: {...prevState.pagination, count: 0},
                userAccess: getUserAccess(this.props.menuAccess, this.state.selectedCabang?.value),
                tableColumns: [
                    ...tableColumns.mainPage(
                        getUserAccess(this.props.menuAccess, this.state.selectedCabang?.value),
                        this.state.dataTable,
                        this.handleModifyingModalVisibility,
                        this.handleDeleteVisibility
                    )
                ]
            }), async () => {
                await this.fetchDataMasterBBN(removeNullFields(this.parseFilterData(this.state.search)), 1, 5)
                await this.fetchDataSamsat();
            })
            this.handleTriggerLoading();
        }
    }

    fetchDataSamsat = async () => {
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSamsat,
            menuName: "Master Table BBN",
            setError: this.props.setError,
            args: {listCabang: [this.state.selectedCabang?.value]}
        });

        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            let {data} = response.data;
            let dataSamsat = data?.map((item) => mapToObjectDDL(item.samsatName, item.samsatId));
            dataSamsat.unshift(mapToObjectDDL("ALL", "ALL"));
            this.setState((prevValue) => ({
                ...prevValue,
                dataSamsat,
            }));
        }
    }

    fetchDataVariant = async () => {
        let response = await fetchDataAsync({
            asyncFn: await Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
            menuName: "Master Tabel BBN",
            setError: this.props.setError,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            let {data} = response.data;
            let dataVariant = data.map(item => mapToObjectDDL(item.namaVariant, item.kodeVariant));
            dataVariant.unshift(mapToObjectDDL("ALL", "ALL"));
            this.setState((prevValue) => ({
                ...prevValue,
                dataVariant,
            }));
        }
    }

    handleModifyingModalVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: !R.isNil(index) ? {...prevValue.dataTable[index]} : null,
            modifyingVisible: !prevValue.modifyingVisible,
        }));
    };

    handleModalFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleDeleteVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            deleteAction: !prevValue.deleteAction,
            selectedData: !R.isNil(index) ? {...prevValue.dataTable[index]} : null,
            deleteModalVisible: !prevValue.deleteModalVisible,
        }));
    }

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        let requestBody = {
            ...removeNullFields(this.parseFilterData(this.state.filterData)),
        }
        this.handleClearSearch({
            startDate: null,
            endDate: null
        });
        this.handleChangeSubmittedFilterData(requestBody);

        await this.fetchDataMasterBBN(requestBody, 1, this.state.pagination.limit);
        this.handleTriggerLoading();
        this.handleModalFilterVisibility();
    }
    ;

    handleSubmitModifying = async (requestBody) => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveMasterBBN,
            menuName: "Master Tabel BBN",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.handleResetAllFilters();
            this.handleModifyingModalVisibility();
            await this.refetch();
        }
        this.handleTriggerLoading();
    };

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        this.handleClearFilter();
        let requestBody = {
            ...removeNullFields(this.parseFilterData(this.state.search)),
        }
        this.handleChangeSubmittedFilterData(requestBody);

        await this.fetchDataMasterBBN(requestBody, 1, this.state.pagination.limit);
        this.handleTriggerLoading();
    }

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleDelete = async (id) => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterBBN,
            menuName: "Master Tabel BBN",
            setError: this.props.setError,
            args: id,
        });
        this.handleDeleteVisibility();
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.handleResetAllFilters();
            await this.refetch();
        } else if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.handleTriggerLoading();
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleValueChangeSearch = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedCabang: value,
        }));
    };

    handleInputDateChange = (name, value) => {
        let parseValue = M(value).format("DD-MM-YYYY");
        if (R.equals("startDate", name)) {
            if (parseValue > this.state.search.endDate) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    search: {
                        ...prevValue.search,
                        [name]: parseValue,
                        endDate: parseValue,
                    },
                }));
                return;
            }
        }

        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: parseValue,
            },
        }));
    };

    handleClearFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                ...initialData.filter
            }
        }));
    };

    handleClearSearch = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                ...value
            }
        }));
    };

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));
        let {submittedFilterData} = this.state;
        const requestBody = {
            // kodeCabang: this.state.selectedCabang?.value,
            ...submittedFilterData,
        };

        await this.fetchDataMasterBBN(requestBody, page, limit);
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 1,
                page: 1,
                limit: limit,
            }
        }));
        let {submittedFilterData} = this.state;
        const requestBody = {
            // kodeCabang: this.state.selectedCabang?.value,
            ...submittedFilterData,
        };

        await this.fetchDataMasterBBN(requestBody, 1, limit);
        this.handleTriggerLoading();
    }

    handlePrint = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printModalVisible: !prevValue.printModalVisible
        }));
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    refetch = async () => {
        this.fetchDataMasterBBN(removeNullFields(this.parseFilterData(this.state.search)), 1, this.state.pagination.limit);
    };

    fetchDataMasterBBN = async (body = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({...prevValue, pagination: {...prevValue.pagination, count: 0}}));
        let req = {...body, limit, page};
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterBBN,
            menuName: "Master Tabel BBN",
            setError: this.props.setError,
            args: req,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    count: res.data.totalData,
                    limit,
                    page,
                }
            }));

        }
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );
                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData.map(
                            item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                        ),
                        selectedCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        search: {
                            ...prevValue.search,
                            startDate: M(new Date()).format("DD-MM-YYYY"),
                            endDate: M(new Date()).format("DD-MM-YYYY"),
                        },
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    parseFilterData(data) {
        let {dataSamsat, dataVariant} = this.state;
        let kodeVariant = data.kodeVariant?.map(i => i.value);
        let kodeSamsat = data.kodeSamsat?.map(i => i.value);
        if (kodeVariant?.includes("ALL")) {
            kodeVariant = dataVariant.map(i => i.value).filter(i => i !== "ALL");
        }
        if (kodeSamsat?.includes("ALL")) {
            kodeSamsat = dataSamsat.map(i => i.value).filter(i => i !== "ALL");
        }
        return {
            ...data,
            kodeSamsat,
            kodeVariant,
            // kodeCabang: getValueFromDDL(data, "kodeCabang"),
        };
    };

    parseToDate = (date) => {
        const [day, month, year] = date.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    compareDate = () => {
        const [day, month, year] = this.state.search.endDate.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        return date < new Date() ? this.state.search.endDate : M().format("DD-MM-YYYY");
    };

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Tabel BBN",
            setError: this.props.setError,
            args: args,
        })
    };

    handleChangeSubmittedFilterData = (data) => {
        this.setState((prevState) => ({
            ...prevState,
            submittedFilterData: data,
        }));
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: initialData.filter,
            search: initialData.search,
            submittedFilterData: {},
            pagination: {...prevState.pagination, count: 0},
        }));
    };

    render() {
        return (
            <>
                <Container>
                    {/* <SimpleDDL
                        id="select_options_nama_cabang"
                        box="search"
                        name="kodeCabang"
                        containerclassname="width width-250px"
                        placeholder="Nama Cabang"
                        menuPosition="fixed"
                        options={this.state.dataCabang}
                        value={this.state.selectedCabang}
                        onChange={(value, {name}) => this.handleValueChangeSearch(name, value)}
                    /> */}
                    <FlexView
                        style={{justifyContent: "space-between"}}
                        vAlignContent="center"
                        className="margin-top-5px"
                    >
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <p className="margin-bottom-20px">Periode: </p>
                            <SimpleDate
                                id="select_date_from"
                                nextdate
                                maxDate={this.state.search?.endDate}
                                date={this.state.search?.startDate}
                                onChange={(value) => this.handleInputDateChange("startDate", value)}
                            />
                            <span className="margin-bottom-20px">-</span>
                            <SimpleDate
                                id="select_date_to"
                                backdate
                                disabled={R.isNil(this.state.search?.startDate)}
                                minDate={this.state.search?.startDate}
                                date={this.state.search?.endDate}
                                onChange={(value) => this.handleInputDateChange("endDate", value)}
                            />
                            <SimpleButton
                                text="Cari"
                                className="margin-bottom-20px"
                                onClick={this.handleSubmitSearch}
                            />
                        </FlexView>
                        <SimpleButton
                            className={"btn background-red margin-bottom-20px"}
                            styles={{width: "unset"}}
                            onClick={this.handleModalFilterVisibility}
                            icon={<i className="fa fa-qrcode"></i>}
                        />
                    </FlexView>

                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.state.tableColumns}
                        toCount={this.state.pagination.count}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(
                            (tableState) => this.handleChangePage(tableState),
                            (tableState) => this.handleChangeRowsPerPage(tableState),
                        )}
                        footerAdditionalButtons={
                            <>
                                {
                                    this.state.userAccess && this.state.userAccess.createAccess && (
                                        <SimpleButton
                                            onClick={() => this.handleModifyingModalVisibility()}
                                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                                            text={"Tambah"}
                                        />
                                    )
                                }

                                <SimpleButton
                                    secondary
                                    type="button"
                                    text="Cetak"
                                    onClick={() => this.handlePrint()}
                                />
                            </>
                        }
                    />
                </Container>

                {this.state.modifyingVisible && (
                    <MasterBBNModifying
                        {...this.props}
                        deleteAction={this.state.deleteAction}
                        formGroup={formGroupMasterBBN}
                        selectedCabang={this.state.selectedCabang}
                        dataCabang={this.state.dataCabang}
                        selectedData={this.state.selectedData}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                {this.state.deleteModalVisible && (
                    <MasterBBNModifying
                        {...this.props}
                        deleteAction={this.state.deleteAction}
                        formGroup={formGroupMasterBBN}
                        selectedCabang={this.state.selectedCabang}
                        selectedData={this.state.selectedData}
                        initialValues={this.state.selectedData}
                        visible={this.state.deleteModalVisible}
                        onDelete={this.handleDelete}
                        onClickClose={this.handleDeleteVisibility}
                    />
                )}

                {this.state.filterVisible && (
                    <MasterBBNFilter
                        setError={this.props.setError}
                        filterData={this.state.filterData}
                        selectedCabang={this.state.selectedCabang}
                        dataSamsat={this.state.dataSamsat}
                        dataVariant={this.state.dataVariant}
                        visible={this.state.filterVisible}
                        onClickClose={this.handleModalFilterVisibility}
                        onClearFilter={this.handleClearFilter}
                        onValueChange={this.handleValueChange}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}

                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}

                {this.state.printModalVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterBBN);